import React, { useState } from "react";
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  Button,
  Snackbar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download";
import { saveAs } from "file-saver";

const SuccessfulPage = ({ open, onClose, documentBlob }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const handleDownload = () => {
    if (documentBlob) {
      saveAs(documentBlob, "QEStrategy_Report.docx");
      setSnackbarOpen(true);
    } else {
      alert("No document available to download");
    }
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: { xs: "90vw", sm: "70vw", md: "50vw", lg: "40vw" },
            display: "flex",
            flexDirection: "column",
            padding: 3,
            boxSizing: "border-box",
          },
        },
      }}
    >
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ArrowBackIcon
              fontSize="small"
              onClick={onClose}
              sx={{ mr: 1, cursor: "pointer" }}
            />
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Success message */}
        <Box
          mb={7}
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 50, color: "green", mb: 2 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Your report is successfully generated
          </Typography>
        </Box>

        {/* Footer with Cancel and Download button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            position: "absolute",
            bottom: 20,
            right: 20,
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            sx={{
              mr: 2,
              borderRadius: 2,
              textTransform: "none",
              borderColor: "#0094FB",
              fontSize: "13px",
              fontWeight: 500,
              borderWidth: 2,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownload}
            sx={{
              textTransform: "none",
              fontSize: "13px",
              backgroundColor: "#0094FB",
              border: "2px solid #0094FB",
              borderRadius: "8px",
            }}
            startIcon={<DownloadIcon />}
          >
            Download
          </Button>
        </Box>
      </Box>
      {/* Snackbar Notification */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          sx: {
            justifyContent: "center", // centers horizontally
            textAlign: "center", // centers text inside
            backgroundColor: "#1fb260de",
          },
        }}
        message={
          <Typography
            variant="body1"
            sx={{ width: "100%", textAlign: "center" }}
          >
            Report downloaded successfully!
          </Typography>
        }
      />
    </Drawer>
  );
};

export default SuccessfulPage;
